import { axiosClient } from "../request";

//method {get, post} , response in data array for showing list or post data
export const opList = async (method, module, data = {}) => {
  const response = await axiosClient[method](module, data);
  response.data.map((value, index) => {
    console.log("valueeeeeee", value);
    response.data[index] = { ...value, index: index + 1 };
  });
  return response;
};

//method {get, put, delete} , response in data by id or update by id or delete by id
export const opById = async (method, module, id, data = {}) => {
  const response = await axiosClient[method](`${module}/${id}`, data);
  return response;
};
